import { Typography } from '@material-ui/core';
import { ColorDynamic, Stack } from '@superdispatch/ui';
import { useMemo } from 'react';
import { formatPlural } from 'shared/helpers/IntlHelpers';
import styled from 'styled-components';
import {
  displayShipperVehiclesCount,
  getShipperInBusinessSinceYear,
  PostingShipperDTO,
} from '../../data/dto/PostingLoadDTO';

const CaptionSubtitle = styled.div`
  color: ${ColorDynamic.Silver500};
`;

export function PostingShipperInfoTooltip({
  shipper,
}: {
  shipper: PostingShipperDTO;
}) {
  const inBusinessSince = useMemo(
    () =>
      shipper.in_business_since &&
      getShipperInBusinessSinceYear(shipper.in_business_since),
    [shipper],
  );

  return (
    <Stack space="xsmall">
      <div>
        <Typography variant="button">{shipper.name}</Typography>
        {inBusinessSince && (
          <CaptionSubtitle>
            <Typography color="inherit">
              Shipper since {inBusinessSince}
            </Typography>
          </CaptionSubtitle>
        )}
      </div>

      {(shipper.accepted_loads_count != null ||
        shipper.overall_moved_vehicles_count != null) && (
        <div>
          {shipper.accepted_loads_count != null && (
            <Typography>
              <b>{shipper.accepted_loads_count}</b>{' '}
              {formatPlural(shipper.accepted_loads_count, 'load', 'loads')}{' '}
              accepted by you
            </Typography>
          )}
          {shipper.overall_moved_vehicles_count != null && (
            <Typography>
              <b>
                {displayShipperVehiclesCount(
                  shipper.overall_moved_vehicles_count,
                )}
              </b>{' '}
              vehicles moved overall
            </Typography>
          )}
        </div>
      )}
    </Stack>
  );
}
